export default __webpack_public_path__ + "static/media/watches3.0e7f37c1.jfif";